import type { ArticleComponentProps } from "@components/Article/Article";
import ArticleEditRenderer from "@components/Article/ArticleEditRenderer";
import { ArticleMarkdownRenderer } from "@components/Article/ArticleMarkdownRenderer";
import { ArticleReadRenderer } from "@components/Article/ArticleReadRenderer";
import type { ArticlePageData } from "@core/SitePresenter/types/ArticlePage";
import DefaultError from "@ext/errorHandlers/logic/DefaultError";
import ArticleDiffViewWrapper from "@ext/git/core/Diff/components/ArticleDiffViewWrapper";
import { isLiveDiffPage } from "@ext/git/core/Diff/logic/live/liveDiffStore";

const Components: Record<
	ArticlePageData["mode"],
	React.ComponentType<ArticleComponentProps<ArticlePageData["mode"]>>
> = {
	edit: ArticleEditRenderer,
	read: ArticleReadRenderer,
	markdown: ArticleMarkdownRenderer,
};

export const ArticleComponent = ({ data, isReadOnly }: ArticleComponentProps<ArticlePageData["mode"]>) => {
	const Component = Components[data.mode];
	if (!Component) throw new DefaultError("Invalid article mode", null, { errorCode: "invalid-article-mode" });

	const liveDiff = isLiveDiffPage(data);
	if (data?.diff && !liveDiff) {
		return <ArticleDiffViewWrapper data={data.diff} isReadOnly={isReadOnly} />;
	}

	return <Component data={data} isReadOnly={isReadOnly} />;
};
